import { render, staticRenderFns } from "./cbdw_list.vue?vue&type=template&id=0067b297&scoped=true&"
import script from "./cbdw_list.vue?vue&type=script&lang=js&"
export * from "./cbdw_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0067b297",
  null
  
)

export default component.exports